import { render, staticRenderFns } from "./UpdateConfirm.vue?vue&type=template&id=950c8348&"
import script from "./UpdateConfirm.vue?vue&type=script&lang=js&"
export * from "./UpdateConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports